import React from 'react'
import styled from '@emotion/styled'

import {NoStyleButton} from '@vio/atlas/helpers/NoStyleButton'
import {Icon} from '@vio/atlas/Icon'
import {User} from '@vio/core/src/auth/types/Cognito'
import {UserAvatar} from '@vio/shared/src/user/account/UserAvatar'

type Props = {
  onShowPreferences?: () => void
  shouldShowUserAvatar: boolean
  user?: User
  hideBurgerMenu?: boolean
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const MobileHeaderMenu = ({
  onShowPreferences,
  shouldShowUserAvatar,
  user,
  hideBurgerMenu = false
}: Props) => {
  return (
    <Wrapper>
      <NoStyleButton
        onClick={onShowPreferences}
        data-id="ShowPreferencesButton"
        data-testid="ShowPreferencesButton"
      >
        {shouldShowUserAvatar && user ? (
          <UserAvatar user={user} />
        ) : (
          !hideBurgerMenu && <Icon name="Menu" size="md" />
        )}
      </NoStyleButton>
    </Wrapper>
  )
}
